import { getElement } from './element'
import { TCoordinates } from '../../map-manager'
import { createOverlay } from '../base/create-overlay'

export type CircleOverlayOptions = {
  position: naver.maps.LatLng
  zIndex?: number
  strokeColor?: string
  strokeWeight?: number
  fillColor?: string
}

export interface CircleOverlay extends naver.maps.OverlayView {
  _position: naver.maps.LatLng
  _element: HTMLDivElement
  setElementStyle(options: CircleOverlayOptions): void
  setPosition(position: naver.maps.LatLng | TCoordinates): void
  getPosition(): naver.maps.LatLng
}

export const createCircleOverlay = () => {
  const Overlay = createOverlay<CircleOverlay, CircleOverlayOptions>({
    initialize,
  })

  function initialize(this: CircleOverlay, options: CircleOverlayOptions) {
    this._element = getElement({
      zIndex: options.zIndex,
    })

    this.setElementStyle(options)
    this.setPosition(options.position)
  }

  Overlay.prototype.onAdd = function () {
    const { overlayLayer } = this.getPanes()
    overlayLayer.appendChild(this._element)
  }

  Overlay.prototype.onRemove = function () {
    this._element.parentNode?.removeChild(this._element)
  }

  Overlay.prototype.setElementStyle = function (options: CircleOverlayOptions) {
    if (!(this._element.firstElementChild instanceof HTMLElement)) return

    if (options.strokeColor) {
      this._element.firstElementChild.style.borderColor = options.strokeColor
    }
    if (options.strokeWeight) {
      this._element.firstElementChild.style.borderWidth = `${options.strokeWeight}px`
    }
    if (options.fillColor) {
      this._element.firstElementChild.style.backgroundColor = options.fillColor
    }
  }

  Overlay.prototype.draw = function () {
    if (!this.getMap()) return

    const projection = this.getProjection()
    const position = this.getPosition()
    const pixelPosition = projection.fromCoordToOffset(position)

    this._element.style.left = `${pixelPosition.x}px`
    this._element.style.top = `${pixelPosition.y}px`
  }

  Overlay.prototype.setPosition = function (
    position: naver.maps.LatLng | TCoordinates,
  ) {
    if (position instanceof naver.maps.LatLng) {
      this._position = position
    } else {
      this._position = new naver.maps.LatLng(position.lat, position.lng)
    }

    this.draw()
  }

  Overlay.prototype.getPosition = function (): naver.maps.LatLng {
    return this._position
  }

  return Overlay
}
